import React from "react";
import placeholder from "../assets/images/onenote-logo.png";
import { FaPlus } from "react-icons/fa"; // Import the plus icon
import { FaEllipsisV } from "react-icons/fa";
import { MdAddLink, MdLink, MdWorkspacePremium } from "react-icons/md";
import { Flow, Integration } from "../types/types";
import onenote from "../assets/images/onenote.png";
import devops from "../assets/images/azure-devops-planning.png";
import advokatsamfundet from "../assets/images/advokatsamfundet.png";
import sustainability from "../assets/images/sustainability.png";
import bonsai from "../assets/images/bonsai.png";
import microsoft365 from "../assets/images/microsoft365.png";
import rapidlearningcycles from "../assets/images/rapidlearningcycles.png";

interface IntegrationCardProps {
  integration: Integration;
  handleIntegrationClick: (id: string) => void;
}

const IntegrationCard: React.FC<IntegrationCardProps> = ({
  integration: integration,
  handleIntegrationClick,
}) => {

  const imageMap: Record<string, string> = {
    logo: onenote,
    devops: devops,
    advokatsamfundet: advokatsamfundet,
    sustainability: sustainability,
    bonsai: bonsai,
    microsoft365: microsoft365,
    rapidlearningcycles: rapidlearningcycles,
  };

  return (
    <div
      key={integration.id}
      className="integration-card"
      onClick={() => handleIntegrationClick(integration.id)}
    >
      <div className="integration-card-image-container">
        <img
          src={imageMap[integration.logo]}
          alt="Map Placeholder"
          className="integration-card-image"
        />
        {/* <div className="integration-card-pro-feature" title="Premium Plan Feature">💎</div> */}
      </div>
      <div className="integration-card-details">
        <h2>{integration.name}</h2>
        <p>{integration.description}</p>
        {/* <MdLink className="integration-card-plus-icon" /> */}
      </div>
    </div>
  );
};

export default IntegrationCard;
